import { render, staticRenderFns } from "./ContactAboutAdvertisementButton.vue?vue&type=template&id=53d753c8&"
import script from "./ContactAboutAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./ContactAboutAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports